import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["id", "aria-controls", "aria-expanded"]
const _hoisted_2 = ["id", "aria-labelledby"]
const _hoisted_3 = {
  key: 0,
  class: "flow"
}
const _hoisted_4 = {
  key: 1,
  class: "flow"
}
const _hoisted_5 = ["aria-controls", "aria-expanded"]

import { ref } from 'vue';
import ChevronDown from '@src/components/shared/icons/ChevronDown.vue';

interface Props {
	id: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DetailedInfoBox',
  props: {
    id: {}
  },
  setup(__props: any) {




const showExpandedInfo = ref<boolean>( false );


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["detailed-info-box", { 'detailed-info-box--expanded': showExpandedInfo.value }])
  }, [
    _createElementVNode("div", {
      role: "button",
      id: `${__props.id}-control`,
      class: "detailed-info-box__toggle cluster",
      tabindex: "0",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (showExpandedInfo.value = !showExpandedInfo.value)),
      onKeyup: [
        _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (showExpandedInfo.value = !showExpandedInfo.value), ["prevent"]), ["space"])),
        _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (showExpandedInfo.value = !showExpandedInfo.value), ["prevent"]), ["enter"]))
      ],
      "aria-controls": `${__props.id}-content`,
      "aria-expanded": showExpandedInfo.value
    }, [
      _renderSlot(_ctx.$slots, "heading"),
      _createVNode(ChevronDown, {
        class: "detailed-info-box__chevron highlighted-icon",
        "aria-label": _ctx.$t( showExpandedInfo.value ? 'read_less' : 'read_more' )
      }, null, 8, ["aria-label"])
    ], 40, _hoisted_1),
    _createElementVNode("div", {
      class: "detailed-info-box__content flow",
      id: `${__props.id}-content`,
      "aria-live": "assertive",
      "aria-labelledby": `${__props.id}-control`
    }, [
      _cache[4] || (_cache[4] = _createElementVNode("hr", null, null, -1)),
      (!showExpandedInfo.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "collapsed-content")
          ]))
        : _createCommentVNode("", true),
      (showExpandedInfo.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "expanded-content")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        class: "link-button detailed-info-box__read-more",
        type: "button",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (showExpandedInfo.value = !showExpandedInfo.value)),
        "aria-controls": `${__props.id}-content`,
        "aria-expanded": showExpandedInfo.value
      }, [
        _createTextVNode(_toDisplayString(_ctx.$t( showExpandedInfo.value ? 'read_less' : 'read_more' )) + " ", 1),
        _createVNode(ChevronDown, {
          class: "highlighted-icon",
          "aria-hidden": "true"
        })
      ], 8, _hoisted_5)
    ], 8, _hoisted_2)
  ], 2))
}
}

})